var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXboxOneRDirectional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 12,
    stroke: "#BBBBBB",
    strokeWidth: 0.894737
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 17,
    stroke: "#BBBBBB",
    strokeWidth: 1.895
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1044 25V14.0909H21.4084C22.2322 14.0909 22.9354 14.2383 23.5178 14.533C24.1037 14.8242 24.5494 15.2379 24.8548 15.7741C25.1637 16.3068 25.3182 16.9336 25.3182 17.6545C25.3182 18.3789 25.1619 19.0021 24.8494 19.5241C24.5369 20.0426 24.0842 20.4403 23.4911 20.7173C22.9016 20.9943 22.1879 21.1328 21.3498 21.1328H18.468V19.2791H20.9769C21.4173 19.2791 21.783 19.2187 22.0742 19.098C22.3654 18.9773 22.582 18.7962 22.7241 18.5547C22.8697 18.3132 22.9425 18.0131 22.9425 17.6545C22.9425 17.2923 22.8697 16.9869 22.7241 16.7383C22.582 16.4897 22.3636 16.3015 22.0689 16.1737C21.7777 16.0423 21.4102 15.9766 20.9663 15.9766H19.4109V25H17.1044ZM22.9957 20.0355L25.707 25H23.1609L20.5082 20.0355H22.9957Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXboxOneRDirectional);
export default __webpack_public_path__ + "static/media/XBOXOne-RDirectional.9d084c3a070cf868271c63cef476372a.svg";
export { ForwardRef as ReactComponent };